module.exports = __webpack_public_path__ + "media/pl_pl_s4_Lidia.82894f4d.mp3";